import type { RecallTopicIcon } from '@rock/types';
import {
    Accessibility,
    Baby,
    BatteryCharging,
    BedDouble,
    Bike,
    Dumbbell,
    Flame,
    House,
    Lightbulb,
    type LucideIcon,
    Pill,
    Plug,
    Shield,
    Shovel,
    ToyBrick,
    Tractor,
    Waves,
} from 'lucide-react';
import type { FC } from 'react';

const GLYPHS: Record<RecallTopicIcon, LucideIcon> = {
    waves: Waves,
    baby: Baby,
    'toy-brick': ToyBrick,
    'bed-double': BedDouble,
    accessibility: Accessibility,
    flame: Flame,
    'battery-charging': BatteryCharging,
    pill: Pill,
    bike: Bike,
    shovel: Shovel,
    tractor: Tractor,
    dumbbell: Dumbbell,
    lightbulb: Lightbulb,
    shield: Shield,
    house: House,
    plug: Plug,
};

/** A topic's icon as the app draws it; a topic without one shows the shield. */
export const RecallTopicIconGlyph: FC<{ icon: RecallTopicIcon | undefined; className?: string }> = ({
    icon,
    className,
}) => {
    const Glyph = (icon && GLYPHS[icon]) ?? Shield;
    return <Glyph className={className} aria-hidden="true" />;
};
